import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import { SiteConfigProvider } from './context/SiteConfigContext';
import { StreamersProvider } from './context/StreamersContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import Classes from './pages/Classes';
import Download from './pages/Download';
import Rankings from './pages/Rankings';
import Streamers from './pages/Streamers';
import News from './pages/News';
import UserCP from './pages/UserCP';
import ForgotPassword from './pages/ForgotPassword';
import GameGuideLayout from './components/game/GameGuideLayout';
import GameGuideHome from './pages/game/GameGuideHome';
import GameGuideArticle from './pages/game/GameGuideArticle';
import MountGuideHome from './pages/game/MountGuideHome';
import MountGuideRegion from './pages/game/MountGuideRegion';
import MountGuideDetail from './pages/game/MountGuideDetail';
import AdminLayout from './components/admin/AdminLayout';
import AdminDashboard from './pages/AdminDashboard';
import AdminNews from './pages/AdminNews';
import AdminDownloads from './pages/AdminDownloads';
import AdminGuides from './pages/AdminGuides';
import AdminMountGuide from './pages/AdminMountGuide';
import AdminEventPackages from './pages/AdminEventPackages';
import AdminSiteConfig from './pages/AdminSiteConfig';
import AdminStreamers from './pages/AdminStreamers';
import NewsDetail from './pages/NewsDetail';
import Store from './pages/Store';
import Donate from './pages/Donate';
import DonateReturn from './pages/DonateReturn';
import './styles/global.css';

function PublicLayout() {
  return (
    <div className="App">
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/classes" element={<Classes />} />
          <Route path="/game" element={<GameGuideLayout />}>
            <Route index element={<GameGuideHome />} />
            <Route path="montarias" element={<MountGuideHome />} />
            <Route path="montarias/:regionSlug" element={<MountGuideRegion />} />
            <Route path="montarias/:regionSlug/:mountSlug" element={<MountGuideDetail />} />
            <Route path=":slug" element={<GameGuideArticle />} />
          </Route>
          <Route path="/download" element={<Download />} />
          <Route path="/rankings" element={<Rankings />} />
          <Route path="/live" element={<Streamers />} />
          <Route path="/news" element={<News />} />
          <Route path="/news/:id" element={<NewsDetail />} />
          <Route path="/usercp" element={<UserCP />} />
          <Route path="/store" element={<Store />} />
          <Route path="/donate" element={<Donate />} />
          <Route path="/donate/return" element={<DonateReturn />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <SiteConfigProvider>
      <LanguageProvider>
        <StreamersProvider>
          <Router>
          <Routes>
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<AdminDashboard />} />
              <Route path="news" element={<AdminNews />} />
              <Route path="guides" element={<AdminGuides />} />
              <Route path="mount-guide" element={<AdminMountGuide />} />
              <Route path="downloads" element={<AdminDownloads />} />
              <Route path="event-packages" element={<AdminEventPackages />} />
              <Route path="streamers" element={<AdminStreamers />} />
              <Route path="settings" element={<Navigate to="/admin/settings/general" replace />} />
              <Route path="settings/:section" element={<AdminSiteConfig />} />
            </Route>
            <Route path="/*" element={<PublicLayout />} />
          </Routes>
        </Router>
        </StreamersProvider>
      </LanguageProvider>
    </SiteConfigProvider>
  );
}

export default App;
